import { ConfigData, FileType, OssConfigData, OssMediaType, UploadFileMark } from '@/types/config';
import { requestWrapper } from '@/utils/request';

// 获取oss配置
export async function getOssConfig(params: {
  up_type?: FileType; // 文件类型，1上传非视频（图片、音频等），2 上传视频
  up_zone?: number; // 上传区域，1北京oss, 2深圳oss(直播相关), 3杭州oss, 4上海oss
  mark?: UploadFileMark; // 上传标记，1默认值，2上传课程照片, 3 老师评价作业音频，4课堂视频、预告视频, 5人脸照片, 6商户作品视频
  upload_version?: number; // 上传版本，1 表示公共转码链路，由后端按场景决定是否启用
  media_type?: OssMediaType; // 课堂视频媒体类型，1正常课堂视频，2预告片；仅课堂视频/预告片场景需要
}) {
  const defaultParams = {
    up_type: FileType.IMAGE,
    up_zone: 1,
    mark: UploadFileMark.DEFAULT,
    upload_version: 1,
  };
  return requestWrapper<OssConfigData>('/api/oss/config_sts', {
    method: 'GET',
    params: { ...defaultParams, ...params },
  });
}

// 获取配置信息
export async function getConfig() {
  return requestWrapper<ConfigData>('/api/config', {
    method: 'GET',
  });
}

// 请求路径生成小程序二维码
export async function getMiniProgramQrCode(data: { path: string }) {
  return requestWrapper<any>('/api/merchant/wx_qr_code', {
    method: 'POST',
    data,
  });
}
